import Svg, { Path } from 'react-native-svg'

export const Copy = ({ width, height, color = '#0186b0' }: any) => {
  return (
    <Svg xmlns="http://www.w3.org/2000/svg" width={width} color={'#0186b0'} height={height} viewBox="0 0 10 10">
      <Path
        fill={color}
        d="M-4.5-8.625V-10.5h-2.187a.938.938 0 00-.937.937v5.625A.938.938 0 00-6.687-3h3.75A.938.938 0 00-2-3.937V-8h-1.875a.627.627 0 01-.625-.625zm.625-1.875v1.875H-2zM-8.25-3.625V-8h-2.812a.937.937 0 00-.938.938v5.625a.937.937 0 00.938.937h3.75a.937.937 0 00.938-.937v-.937H-7a1.25 1.25 0 01-1.25-1.251z"
        data-name="Main text"
        transform="translate(12 10.5)"
      />
    </Svg>
  )
}
